import React from "react";
import { TabItem } from "./TabItem";
import {
  ClientTab1Image,
  ClientTab2Image,
  ClientTab3Image,
} from "../../../assets";

export const ClientTab = () => {
  return (
    <div className="grid gap-6 xl:grid-cols-2 mt-[44px] min-w-0">
      <TabItem
        title="Easy Booking & Flexible Scheduling"
        description="Clients can book health and beauty services at their convenience, choosing from various time slots and locations, making the process hassle-free."
        image={ClientTab1Image}
        className="grid-rows-[auto_1fr]"
        variant="client"
        centeredImage
        imgClassName="max-w-[420px] mx-auto"
      />
      <div className="grid gap-6 min-w-0">
        <TabItem
          className="lg:grid-cols-2 lg:items-center"
          title="Seamless Payment System"
          description="Secure, quick payments integrated into the platform, allowing clients to pay easily before or after their session without needing to deal with cash."
          image={ClientTab2Image}
          variant="client"
          centeredImage
          imgClassName="max-h-[360px] sm:max-h-[420px]"
        />
        <TabItem
          className="lg:grid-cols-2 lg:items-center"
          title="Personalized Hero Matching"
          description="Filter Meind Therapy Heros by wellness, spa, massage, or beauty specialty so clients find the right health and beauty fit every time."
          image={ClientTab3Image}
          variant="client"
          centeredImage
          imgClassName="max-h-[300px] sm:max-h-[360px]"
        />
      </div>
    </div>
  );
};
